import React from "react";
const PlusIcon: React.FC<React.SVGAttributes<NonNullable<unknown>>> = (
  props,
) => (
  <svg
  xmlns="http://www.w3.org/2000/svg"
    width={11}
    height={11}
    fill="none"
    {...props}
>
  <path
    fill="#8065C9"
    d="M5.5 0a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11Zm0 10.323C2.846 10.323.687 8.153.687 5.5A4.818 4.818 0 0 1 5.5.687 4.818 4.818 0 0 1 10.313 5.5c0 2.654-2.16 4.823-4.813 4.823Zm2.406-5.167H5.844V3.094a.344.344 0 0 0-.688 0v2.062H3.094a.344.344 0 0 0 0 .688h2.062v2.062a.344.344 0 0 0 .688 0V5.844h2.062a.344.344 0 0 0 0-.688Z"
  />
  <path d="M12 6.834h3.692v18H20" stroke="#8065C9" />
</svg>
);

export default PlusIcon;
